module.exports = ".btn-group.btn-group-sm .btn.active, .btn-group.btn-group-sm .btn.focus, .btn-group.btn-group-sm .btn:focus {\n  box-shadow: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button-options.component.scss
// module id = 589
// module chunks = 1